import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { AgingReportPDFApi } from "./AgingAction"
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { GetLevelFourDropDownApi } from "../LevelFour/LevelFourAction";
import _ from "lodash";
import Select from 'react-select';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import { GlobalSpinner } from "../../../../../global/globalFunctions";


const AgingReport = (props) => {
    const [levelFourId, setLevelFourId] = useState("");
    const [levelFourName, setLevelFourName] = useState("");
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const ExportPDF = () => {
        props.AgingReportPDFApi({
            startDate: !_.isEmpty(startDate) ? startDate : "",
            endDate: !_.isEmpty(endDate) ? endDate : "",
            levelFourId: levelFourId,
            levelFourName: levelFourName,
        },
            startDate,
            endDate,
            levelFourName
        );
    }

    const handleChangeLevelFour = (selectedOption) => {
        setLevelFourId(selectedOption.value);
        setLevelFourName(selectedOption.label)
    };
    const levelFourList = props.levelFourDropDownList?.length ? props.levelFourDropDownList.map(x => ({
        value: x._id,
        label: `${x.allLevelKey} - ${x.levelFourName}`,
    })) : [];

    useEffect(() => {
        props.GetLevelFourDropDownApi();
        props.setHeading("Aging Report");
    }, []);

    return (
        <>
            {props.isFetchingLevelFourDropDown ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        {/* <Col>
                            <Form.Group>
                                <Form.Label><b>Start Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label><b>End Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col> */}
                        <Col>
                            <Form.Group>
                                <Form.Label><b> Select Account *</b></Form.Label>
                                <Select
                                    placeholder="Select Account"
                                    onChange={handleChangeLevelFour}
                                    options={levelFourList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv" >
                        {levelFourId === "" ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> <b>GENERATE PDF </b> </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => ExportPDF()}> <b>GENERATE PDF </b> </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
        AgingReportPDFApi: (data, startDate, endDate, accountName) => dispatch(AgingReportPDFApi(data, startDate, endDate, accountName)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
    levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AgingReport);